export const ROUTE_CONST = {
  DEFAULT: "DEFAULT",
  HOME: "HOME",
  LOGIN: "LOGIN",
  ITEMS: "ITEMS",

  CART: "CART",
  CUSTOMERS: "CUSTOMERS",
  CARTDEFSELECTIONHOME: "CARTDEFSELECTIONHOME",
  ERROR: "ERROR",
  CARTDEFSELECTION: "CARTDEFSELECTION",
  ITEMDETAIL: "ITEMDETAIL",
  ORDERCONFIRMATION: "ORDERCONFIRMATION",
  DELETEORDERCONFIRMATION: "DELETEORDERCONFIRMATION",
  PAGENOTFOUND: "PAGENOTFOUND",
  INVITATION: "INVITATION",

  STANDINGORDER: "STANDINGORDER",
  STANDINGORDERITEMS: "STANDINGORDERITEMS",
  ADDSTANDINGORDER: "ADDSTANDINGORDER",

  STANDINGORDERSUMMARY: "STANDINGORDERSUMMARY",
};
